<template>
  <Dashboard>
    <!-- daterange-header -->
    <div class="inventory-header lead-header">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="leads-btn">
            <div class="btns-group">
              <a class="cus-btn" href="javascript:;" @click="resetFilters"
                >Reset</a
              >
            </div>
            <div class="search-box">
              <input
                type="text"
                class="reportrange form-control daterangebackground"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- daterange-header -->
    <!-- channel-table -->
    <div class="channel-tabel">
      <div class="row">
        <div class="col-lg-6">
          <!-- Analytics-table -->
          <div class="table-area hide-select-search">
            <table class="display" id="topStatesTable">
              <thead>
                <tr>
                  <th>Top 10 States</th>
                  <th>Sessions</th>
                  <th>New Sessions</th>
                  <th>New Users</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in topTenStatesSessions" :key="item">
                  <td>{{ item[0] }}</td>
                  <td>{{ item[1] }}</td>
                  <td>{{ item[2] }}</td>
                  <td>{{ item[3] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Analytics-table -->
        </div>

        <div class="col-lg-6">
          <!-- Analytics-table -->
          <div class="table-area hide-select-search">
            <table class="display" id="topCitiesTable">
              <thead>
                <tr>
                  <th>Top 10 Cities</th>
                  <th>Sessions</th>
                  <th>New Sessions</th>
                  <th>New Users</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in topTenCitiesSessions" :key="item">
                  <td>{{ item[0] }}</td>
                  <td>{{ item[1] }}</td>
                  <td>{{ item[2] }}</td>
                  <td>{{ item[3] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Analytics-table -->
        </div>
      </div>
    </div>
    <!-- channel-table -->
  </Dashboard>
</template>
<script>
import $ from "jquery";
import { onMounted, ref } from "vue";
import "daterangepicker";
import moment from "moment";
import axios from "axios";
import Dashboard from "./../../../layouts/Dashboard.vue";
export default {
  components: {
    Dashboard,
  },
  setup() {
    let startDate = ref(moment().subtract(29, "days"));
    let endDate = ref(moment());

    let topTenStatesSessions = ref([]);
    let topTenStatesSessionsError = ref("");
    let topTenCitiesSessions = ref([]);
    let topTenCitiesSessionsError = ref("");

    const getTopTenStatesSessions = async () => {
      await axios
        .post(
          axios.defaults.baseUrl + "getTopTenStatesSessions",
          {
            startDate: startDate.value,
            endDate: endDate.value,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("auth_token"),
            },
          }
        )
        .then((response) => {
          topTenStatesSessions.value = response.data.data.rows;

          if ($.fn.DataTable.isDataTable("#topStatesTable")) {
            $("#topStatesTable").DataTable().clear().destroy();
          }
          setTimeout(() => {
            $("#topStatesTable").addClass("nowrap").dataTable({
              responsive: true,
              fixedHeader: true,
            });
          });
        })
        .catch((topTenStatesSessionsError) => {
          topTenStatesSessionsError.value =
            "No Sessions for Google Analytics found";
        });
    };

    const getTopTenCitiesSessions = async () => {
      await axios
        .post(
          axios.defaults.baseUrl + "getTopTenCitiesSessions",
          {
            startDate: startDate.value,
            endDate: endDate.value,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("auth_token"),
            },
          }
        )
        .then((response) => {
          topTenCitiesSessions.value = response.data.data.rows;
          if ($.fn.DataTable.isDataTable("#topCitiesTable")) {
            $("#topCitiesTable").DataTable().clear().destroy();
          }
          setTimeout(() => {
            $("#topCitiesTable").addClass("nowrap").dataTable({
              responsive: true,
              fixedHeader: true,
            });
          });
        })
        .catch((topTenCitiesSessionsError) => {
          topTenCitiesSessionsError.value =
            "No Sessions for Google Analytics found";
        });
    };

    const cb = (start, end) => {
      startDate.value = start.format("YYYY-MM-DD");
      endDate.value = end.format("YYYY-MM-DD");
      getTopTenCitiesSessions();
      getTopTenStatesSessions();
      $(".reportrange span").html(
        start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY")
      );
    };

    const resetFilters = () => {
      startDate.value = moment().subtract(29, "days");
      endDate.value = moment();
      dateRangePickerInit();
    };

    const dateRangePickerInit = async () => {
      $(".reportrange").daterangepicker(
        {
          startDate: startDate.value,
          endDate: endDate.value,
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
          },
        },
        cb
      );
      cb(startDate.value, endDate.value);
    };

    onMounted(() => {
      $("#topStatesTable").addClass("nowrap").dataTable({
        responsive: true,
        fixedHeader: true,
      });
      $("#topCitiesTable").addClass("nowrap").dataTable({
        responsive: true,
        fixedHeader: true,
      });
      dateRangePickerInit();
    });

    return {
      topTenStatesSessions,
      topTenCitiesSessions,
      topTenStatesSessionsError,
      topTenCitiesSessionsError,
      resetFilters,
    };
  },
};
</script>